import { Component, OnInit } from '@angular/core';
import { ContentfulService } from 'src/app/core/contentful.service';
import { Entry } from 'contentful';
import { NavbarService } from '../../core/navbar.service';
import { SeoService } from '../../core/seo.service';

@Component({
  selector: 'app-past-events',
  templateUrl: './past-events.component.html',
  styleUrls: ['./past-events.component.css']
})
export class PastEventsComponent implements OnInit {
  pastEvents: Entry<any>[] = [];
  filteredEvents: Entry<any>[] = [];
  years: number[] = [];
  selectedYear: string = 'all';
  loading: boolean = true;

  constructor(
    private contentfulService: ContentfulService,
    public nav: NavbarService,
    private seo: SeoService
  ) { }

  ngOnInit() {
    this.nav.show();
    this.loadPastEvents();
    this.seo.updateTags({
      title: 'Past Events & Activities Archive',
      description: 'Browse our archive of past events, exhibits, and community activities at the Bayou Lacombe Museum in Lacombe, Louisiana.',
      url: '/past-events'
    });
  }

  loadPastEvents() {
    this.contentfulService.getPastEvents()
      .then(events => {
        this.pastEvents = events;
        this.filteredEvents = events;
        this.extractYears();
        this.loading = false;
      })
      .catch(error => {
        console.error('Error loading past events:', error);
        this.loading = false;
      });
  }

  extractYears() {
    const yearSet = new Set<number>();
    this.pastEvents.forEach(event => {
      if (event.fields.date) {
        const year = new Date(event.fields.date).getFullYear();
        yearSet.add(year);
      }
    });
    this.years = Array.from(yearSet).sort((a, b) => b - a); // Newest first
  }

  filterByYear(year: string) {
    this.selectedYear = year;
    if (year === 'all') {
      this.filteredEvents = this.pastEvents;
    } else {
      this.filteredEvents = this.pastEvents.filter(event => {
        const eventYear = new Date(event.fields.date).getFullYear();
        return eventYear.toString() === year;
      });
    }
  }
}
